import React from 'react'
import PropTypes from 'prop-types'

const EmailIcon = ({ style, className, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <g fill="#007AFA" fillRule="nonzero">
        <path d="M10 12l-1.732-1.516-4.952 4.245c.18.167.423.271.691.271h11.986c.267 0 .509-.104.688-.271l-4.949-4.245L10 12z" />
        <path d="M16.684 5.271A1.007 1.007 0 0 0 15.993 5H4.007c-.267 0-.509.104-.689.273L10 11l6.684-5.729zM3 5.878v8.308l4.833-4.107zM12.167 10.079L17 14.186V5.875z" />
      </g>
    </g>
  </svg>
)

EmailIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default EmailIcon
